module.exports = __webpack_public_path__ + "img/js6_g356.fa578533.jpg";